var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { EventObject } from "./EventObject";
import { SearchPickerChoices } from "./SearchPickerChoices";
import { SearchPickerResults } from "./SearchPickerResults";
import { DefaultSearchPickerOptions } from "./options/DefaultSearchPickerOptions";
import { Utility } from "./Utils";
var SearchPicker = /** @class */ (function (_super) {
    __extends(SearchPicker, _super);
    function SearchPicker(container, options) {
        var _this = _super.call(this) || this;
        _this.container = container;
        _this.pickerItems = [];
        _this.searchTmrId = null;
        _this.isMobile = isMobile();
        _this.options = _this.extendOptions(new DefaultSearchPickerOptions(), options);
        _this.setupHtml();
        _this.bindEvents();
        return _this;
    }
    SearchPicker.prototype.getChoices = function () {
        return this.choices.selected;
    };
    SearchPicker.prototype.clearChoices = function () {
        this.choices.removeAll();
    };
    SearchPicker.prototype.addChoice = function (item) {
        this.choices.addChoice(item);
        this.results.addSelectedResult(item);
    };
    SearchPicker.prototype.removeChoice = function (item) {
        this.choices.removeChoice(item);
        this.results.removeSelectedResult(item);
    };
    SearchPicker.prototype.updateSource = function (source) {
        this.options.source = source;
        this.results.updateOptions(this.options);
    };
    SearchPicker.prototype.focus = function () {
        this.choices.focus();
    };
    SearchPicker.prototype.allowInput = function () {
        this.choices.forbidInput = false;
    };
    SearchPicker.prototype.forbidInput = function () {
        this.choices.forbidInput = true;
    };
    SearchPicker.prototype.setupHtml = function () {
        Utility.addClass(this.container, 'container');
        this.applyTemplate();
        this.choices = new SearchPickerChoices(this.choicesElm, this.options, this.isMobile);
        this.results = new SearchPickerResults(this.choicesElm, this.options);
    };
    SearchPicker.prototype.bindEvents = function () {
        var _this = this;
        this.container.onclick = function () { return _this.onClick(); };
        this.container.onmouseleave = function () {
            _this.choices.keepActive = false;
        };
        this.container.onmouseenter = function () {
            _this.choices.keepActive = true;
        };
        this.choices.on('search', function (text) {
            _this.onSearch(text);
        });
        this.choices.on('blur', function () {
            _this.inFocus = false;
            _this.results.setProcessSearchResponses(false);
            _this.results.hide();
        });
        this.choices.on('focus', function () { return _this.onChoiceFocus(); });
        this.choices.on('escape', function () {
            _this.onEscape();
        });
        this.choices.on('tab', function (e) {
            _this.choices.keepActive = false;
            _this.onSelect(e, 'tab');
        });
        this.choices.on('enter', function (e) {
            _this.onSelect(e, 'enter');
        });
        this.choices.on('arrowDown', function () { return _this.results.moveSelectedDown(); });
        this.choices.on('arrowUp', function () { return _this.results.moveSelectedUp(); });
        this.choices.on('choiceRemoved', function (item) { return _this.onChoiceRemoved(item); });
        this.results.on('resultSelected', function (result, query, selectedVia, rank, count) { return _this.onResultSelected(result, query, selectedVia, rank, count); });
        this.results.on('highlight', function (_a) {
            var item = _a.item, changed = _a.changed;
            if (item) {
                _this.choices.setAutocompleteText(item.title);
            }
        });
    };
    SearchPicker.prototype.onSearch = function (text) {
        if (text.length < this.options.minLengthToSearch || !this.choices.canSelectMoreChoices()) {
            this.results.hide();
            //случай, когда приходит устаревший поиск уже при пустом/недостаточно длинном поле
            this.results.setProcessSearchResponses(false);
        }
        else if (this.inFocus) {
            this.results.search(text);
            this.results.setProcessSearchResponses(true);
        }
    };
    SearchPicker.prototype.onChoiceRemoved = function (item) {
        this.results.removeSelectedResult(item);
        this.$notifyEvent('choiceRemoved', item);
        this.results.setTop(this.choices.getHeight());
        if (!this.choices.selected.length) {
            this.onChoiceFocus();
        }
    };
    SearchPicker.prototype.onChoiceFocus = function () {
        this.inFocus = true;
        this.onSearch(this.choices.getSearchText());
    };
    SearchPicker.prototype.onClick = function () {
        this.choices.focus();
    };
    SearchPicker.prototype.onEscape = function () {
        this.results.hide();
    };
    SearchPicker.prototype.onSelect = function (e, selectedVia) {
        if (!this.results.isShown)
            return;
        e.preventDefault();
        this.results.selectHighlighted(selectedVia);
    };
    SearchPicker.prototype.onResultSelected = function (result, query, selectedVia, rank, totalCount) {
        this.choices.addChoice(result);
        this.results.hide();
        this.results.addSelectedResult(result);
        this.results.setTop(this.choices.getHeight());
        this.$notifyEvent('choiceAdded', result, query, selectedVia, rank, totalCount);
    };
    SearchPicker.prototype.applyTemplate = function () {
        this.choicesElm = document.createElement('ul');
        this.choicesElm.className = 'choices form-control';
        if (this.options.maxSelectedChoices === 1) {
            Utility.addClass(this.choicesElm, "sole-choice");
        }
        this.container.appendChild(this.choicesElm);
    };
    SearchPicker.prototype.extendOptions = function (def, user) {
        var result = {};
        for (var prop in user) {
            result[prop] = user[prop];
        }
        for (var prop in def) {
            if (typeof (user[prop]) == 'undefined')
                result[prop] = def[prop];
        }
        return result;
    };
    return SearchPicker;
}(EventObject));
export { SearchPicker };
export function isMobile() {
    return !!(navigator.userAgent.match(/Android/i)
        || navigator.userAgent.match(/webOS/i)
        || navigator.userAgent.match(/iPhone/i)
        || navigator.userAgent.match(/iPad/i)
        || navigator.userAgent.match(/iPod/i)
        || navigator.userAgent.match(/BlackBerry/i)
        || navigator.userAgent.match(/Windows Phone/i));
}
